import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// Import translation files
import enCommon from "../locales/en/common.json";
import enAuth from "../locales/en/auth.json";
import enDashboard from "../locales/en/dashboard.json";
import enNavbar from "../locales/en/navbar.json";
import enChooseOrg from "../locales/en/chooseOrg.json";
import enChooseOutlet from "../locales/en/chooseOutlet.json";
import enChooseModule from "../locales/en/chooseModule.json";
import enSidebar from "../locales/en/sidebar.json";
import enSalesDashboard from "../locales/en/salesDashboard.json";
import enSales from "../locales/en/sales.json";
import enQuotations from "../locales/en/quotations.json";
import enSaleReturns from "../locales/en/saleReturns.json";
import enTransactions from "../locales/en/transactions.json";
import enOutletShifts from "../locales/en/outletShifts.json";
import enProducts from "../locales/en/products.json";
import enEbmImports from "../locales/en/ebmImports.json";
import enEbmPurchases from "../locales/en/ebmPurchases.json";
import enSyncEbmNotices from "../locales/en/syncEbmNotices.json";
import enSalesReports from "../locales/en/salesReports.json";
import enGeneralSalesSettings from "../locales/en/generalSalesSettings.json";
import enGeneralFinanceSettings from "../locales/en/generalFinanceSettings.json";
import enSanctionTypes from "../locales/en/sanctionTypes.json";
import enEmployeeSanctions from "../locales/en/employeeSanctions.json";
import enCustomers from "../locales/en/customers.json";
import enTaxRates from "../locales/en/taxRates.json";
import enCategories from "../locales/en/categories.json";
import enFacilityActivities from "../locales/en/facilityActivities.json";
import enFacilityBookings from "../locales/en/facilityBookings.json";
import enFacilityCalendar from "../locales/en/facilityCalendar.json";
import enFacilityDashboard from "../locales/en/facilityDashboard.json";
import enFacilityPayments from "../locales/en/facilityPayments.json";
import enFacilitySettings from "../locales/en/facilitySettings.json";
import enFacilityGuests from "../locales/en/facilityGuests.json";
import enFacilityEnquiries from "../locales/en/facilityEnquiries.json";
import enFacilityPortal from "../locales/en/facilityPortal.json";
import enFacilityPortalSettings from "../locales/en/facilityPortalSettings.json";
import enUnits from "../locales/en/units.json";
import enUnitsConversions from "../locales/en/unitsConversions.json";
import enPosOutlets from "../locales/en/posOutlets.json";
import enPaymentMethods from "../locales/en/paymentMethods.json";
import enPrintBarCodes from "../locales/en/printBarCodes.json";
import enPresets from "../locales/en/presets.json";
import enBreadcrumbs from "../locales/en/breadcrumbs.json";
import enPos from "../locales/en/pos.json";
import enKds from "../locales/en/kds.json";
import enCart from "../locales/en/cart.json";
import enPaymentScreen from "../locales/en/paymentScreen.json";
import enSaleForm from "../locales/en/saleForm.json";
import enBookingForm from "../locales/en/bookingForm.json";
import enQuotationForm from "../locales/en/quotationForm.json";
import enSaleReturnForm from "../locales/en/saleReturnForm.json";
import enShiftModals from "../locales/en/shiftModals.json";
import enProductForm from "../locales/en/productForm.json";
import enUnitsForm from "../locales/en/unitsForm.json";
import enImportEbmImports from "../locales/en/importEbmImports.json";
import enSalesByItems from "../locales/en/salesByItems.json";
import enSalesBySalesperson from "../locales/en/salesBySalesperson.json";
import enSalesByServiceProvider from "../locales/en/salesByServiceProvider.json";
import enSalesByCustomer from "../locales/en/salesByCustomer.json";
import enBulkImport from "../locales/en/bulkImport.json";
import enZReport from "../locales/en/zReport.json";
import enXReport from "../locales/en/xReport.json";
import enPluReport from "../locales/en/pluReport.json";
import enEbmSalesReport from "../locales/en/ebmSalesReport.json";
import enRestaurantDashboard from "../locales/en/restaurantDashboard.json";
import enRestaurantOrders from "../locales/en/restaurantOrders.json";
import enRestaurantOrderDetails from "../locales/en/restaurantOrderDetails.json";
import enRestaurantTickets from "../locales/en/restaurantTickets.json";
import enRestaurantSalesItems from "../locales/en/restaurantSalesItems.json";
import enMenuItems from "../locales/en/menuItems.json";
import enEbmBills from "../locales/en/ebmBills.json";
import enWorkPeriods from "../locales/en/workPeriods.json";
import enWorkPeriodDetails from "../locales/en/workPeriodDetails.json";
import enCreateWorkPeriodReport from "../locales/en/createWorkPeriodReport.json";
import enCloseWorkPeriod from "../locales/en/closeWorkPeriod.json";
import enCreateShiftReport from "../locales/en/createShiftReport.json";
import enCashierReports from "../locales/en/cashierReports.json";
import enCashierSummaryReport from "../locales/en/cashierSummaryReport.json";
import enGeneralCashierReports from "../locales/en/generalCashierReports.json";
import enRestaurantAllowancesReport from "../locales/en/restaurantAllowancesReport.json";
import enSalesByMenus from "../locales/en/salesByMenus.json";
import enSalesByWaiters from "../locales/en/salesByWaiters.json";
import enSalesByStations from "../locales/en/salesByStations.json";
import enSalesCancellationReport from "../locales/en/salesCancellationReport.json";
import enWaiterCancellationsReport from "../locales/en/waiterCancellationsReport.json";
import enRestaurantSettings from "../locales/en/restaurantSettings.json";
import enRestaurantDiscounts from "../locales/en/restaurantDiscounts.json";
import enRestaurantLoyalty from "../locales/en/restaurantLoyalty.json";
import enOrderStations from "../locales/en/orderStations.json";
import enMenuCategories from "../locales/en/menuCategories.json";
import enTables from "../locales/en/tables.json";
import enRestaurantReports from "../locales/en/restaurantReports.json";
import enDatatable from "../locales/en/datatable.json";
import enLogoutModal from "../locales/en/logoutModal.json";
import enRestaurantPosOrders from "../locales/en/restaurantPosOrders.json";
import enRestaurantPosOrder from "../locales/en/restaurantPosOrder.json";
import enNavUser from "../locales/en/navUser.json";
import enChooseDestination from "../locales/en/chooseDestination.json";
import enPaymentModal from "../locales/en/paymentModal.json";
import enTransferModal from "../locales/en/transferModal.json";
import enSplitBillModal from "../locales/en/splitBillModal.json";
import enMergeOrderModal from "../locales/en/mergeOrderModal.json";
import enInventoryLocations from "../locales/en/inventoryLocations.json";
import enInventoryOverview from "../locales/en/inventoryOverview.json";
import enManufacturingOverview from "../locales/en/manufacturingOverview.json";
import enBoms from "../locales/en/boms.json";
import enMenuRecipes from "../locales/en/menuRecipes.json";
import enIngredientUsage from "../locales/en/ingredientUsage.json";
import enBomForm from "../locales/en/bomForm.json";
import enBomDetails from "../locales/en/bomDetails.json";
import enProductionOrders from "../locales/en/productionOrders.json";
import enProductionOrderForm from "../locales/en/productionOrderForm.json";
import enProductionOrderDetails from "../locales/en/productionOrderDetails.json";
import enMaterialRequests from "../locales/en/materialRequests.json";
import enHousekeepingSupplies from "../locales/en/housekeepingSupplies.json";
import enConferenceEvents from "../locales/en/conferenceEvents.json";
import enHotelQuotations from "../locales/en/hotelQuotations.json";
import enMaterialRequestForm from "../locales/en/materialRequestForm.json";
import enMaterialRequestDetails from "../locales/en/materialRequestDetails.json";
import enBatches from "../locales/en/batches.json";
import enBatchDetails from "../locales/en/batchDetails.json";
import enViewBatchesSheet from "../locales/en/viewBatchesSheet.json";
import enSaleBatchDialog from "../locales/en/saleBatchDialog.json";
import enManufacturingReports from "../locales/en/manufacturingReports.json";
import enManufacturingSettings from "../locales/en/manufacturingSettings.json";
import enHotelOverview from "../locales/en/hotelOverview.json";
import enHotelCalendar from "../locales/en/hotelCalendar.json";
import enHotelBookings from "../locales/en/hotelBookings.json";
import enHotelServices from "../locales/en/hotelServices.json";
import enHotelRatePlans from "../locales/en/hotelRatePlans.json";
import enHotelRatePlanForm from "../locales/en/hotelRatePlanForm.json";
import enHotelGuests from "../locales/en/hotelGuests.json";
import enHotelPayments from "../locales/en/hotelPayments.json";
import enHotelOnlineBookings from "../locales/en/hotelOnlineBookings.json";
import enHotelFolios from "../locales/en/hotelFolios.json";
import enHotelReports from "../locales/en/hotelReports.json";
import enHotelRoomTypes from "../locales/en/hotelRoomTypes.json";
import enHotelAgents from "../locales/en/hotelAgents.json";
import enHotelCompanies from "../locales/en/hotelCompanies.json";
import enHotelSettings from "../locales/en/hotelSettings.json";
import enHotelFloors from "../locales/en/hotelFloors.json";
import enHotelBedTypes from "../locales/en/hotelBedTypes.json";
import enHotelAmenities from "../locales/en/hotelAmenities.json";
import enHotelRooms from "../locales/en/hotelRooms.json";
import enHotelRoomAvailability from "../locales/en/hotelRoomAvailability.json";
import enHotelRoomConfig from "../locales/en/hotelRoomConfig.json";
import enHotelCheckout from "../locales/en/hotelCheckout.json";
import enHotelCredits from "../locales/en/hotelCredits.json";
import enHotelPostCharge from "../locales/en/hotelPostCharge.json";
import enHotelRecordService from "../locales/en/hotelRecordService.json";
import enHotelAddAddon from "../locales/en/hotelAddAddon.json";
import enHotelPostPayment from "../locales/en/hotelPostPayment.json";
import enHotelExtendStay from "../locales/en/hotelExtendStay.json";
import enHotelShortenStay from "../locales/en/hotelShortenStay.json";
import enHotelRoomChange from "../locales/en/hotelRoomChange.json";
import enHotelReactivateBooking from "../locales/en/hotelReactivateBooking.json";
import enHotelArrivalsDeparturesReport from "../locales/en/hotelArrivalsDeparturesReport.json";
import enHotelRoomRevenueReport from "../locales/en/hotelRoomRevenueReport.json";
import enHotelGuestsByCountryReport from "../locales/en/hotelGuestsByCountryReport.json";
import enHotelAgentCommissionsReport from "../locales/en/hotelAgentCommissionsReport.json";
import enHousekeeping from "../locales/en/housekeeping.json";
import enInventoryLocationDetails from "../locales/en/inventoryLocationDetails.json";
import enUnitConversionSheet from "../locales/en/unitConversionSheet.json";
import enEditInventorySheet from "../locales/en/editInventorySheet.json";
import enImportInventoryModal from "../locales/en/importInventoryModal.json";
import enImportInventory from "../locales/en/importInventory.json";
import enStockCounting from "../locales/en/stockCounting.json";
import enManualAdjustments from "../locales/en/manualAdjustments.json";
import enInventoryItemAdjustments from "../locales/en/inventoryItemAdjustments.json";
import enManualAdjustmentForm from "../locales/en/manualAdjustmentForm.json";
import enStockThresholdSettings from "../locales/en/stockThresholdSettings.json";
import enGeneralInventorySettings from "../locales/en/generalInventorySettings.json";
import enSuppliers from "../locales/en/suppliers.json";
import enStockItems from "../locales/en/stockItems.json";
import enRequisitionDetails from "../locales/en/requisitionDetails.json";
import enApprovalWorkflow from "../locales/en/approvalWorkflow.json";
import enApprovalWorkflowConfig from "../locales/en/approvalWorkflowConfig.json";
import enConvertToPo from "../locales/en/convertToPo.json";
import enGeneralInformation from "../locales/en/generalInformation.json";
import enThirdPartyIntegrations from "../locales/en/thirdPartyIntegrations.json";
import enGeneralSettings from "../locales/en/generalSettings.json";
import enApiKeysManagement from "../locales/en/apiKeysManagement.json";
import enRequisitions from "../locales/en/requisitions.json";
import enRequisitionForm from "../locales/en/requisitionForm.json";
import enPurchaseOrders from "../locales/en/purchaseOrders.json";
import enPurchaseOrdersForm from "../locales/en/purchaseOrdersForm.json";
import enInternalTransfers from "../locales/en/internalTransfers.json";
import enTransferForm from "../locales/en/transferForm.json";
import enPurchaseInvoices from "../locales/en/purchaseInvoices.json";
import enPurchaseDetail from "../locales/en/purchaseDetail.json";
import enPurchaseInvoiceForm from "../locales/en/purchaseInvoiceForm.json";
import enPurchasePaymentForm from "../locales/en/purchasePaymentForm.json";
import enPurchasePaymentDetails from "../locales/en/purchasePaymentDetails.json";
import enReceivePurchase from "../locales/en/receivePurchase.json";
import enReceivePurchaseForm from "../locales/en/receivePurchaseForm.json";
import enInventoryItems from "../locales/en/inventoryItems.json";
import enSerializedItems from "../locales/en/serializedItems.json";
import enBatchEntry from "../locales/en/batchEntry.json";
import enInsurers from "../locales/en/insurers.json";
import enInsurancePos from "../locales/en/insurancePos.json";
import enInsuranceClaims from "../locales/en/insuranceClaims.json";
import enInsuranceReports from "../locales/en/insuranceReports.json";
import enInsurancePriceLists from "../locales/en/insurancePriceLists.json";
import enSupplierPayments from "../locales/en/supplierPayments.json";
import enStockItemCategories from "../locales/en/stockItemCategories.json";
import enSendPurchaseOrderModal from "../locales/en/sendPurchaseOrderModal.json";
import enAccountSettings from "../locales/en/accountSettings.json";
import enRolesPermissions from "../locales/en/rolesPermissions.json";
import enRoleForm from "../locales/en/roleForm.json";
import enTransferDetails from "../locales/en/transferDetails.json";
import enInvoiceDetails from "../locales/en/invoiceDetails.json";
import enSystemUsers from "../locales/en/systemUsers.json";
import enActivityLogs from "../locales/en/activityLogs.json";
import enBilling from "../locales/en/billing.json";
import enNightAudit from "../locales/en/nightAudit.json";
import enDailyRevenueReport from "../locales/en/dailyRevenueReport.json";
import enOccupancyReport from "../locales/en/occupancyReport.json";
import enInHouseGuestReport from "../locales/en/inHouseGuestReport.json";
import enCreateWorkRequest from "../locales/en/createWorkRequest.json";
import enWorkDetails from "../locales/en/workDetails.json";
import enLiquidProfiles from "../locales/en/liquidProfiles.json";
import enBulkMenuUnits from "../locales/en/bulkMenuUnits.json";
import enBulkProductUnits from "../locales/en/bulkProductUnits.json";
import enProductPrices from "../locales/en/productPrices.json";
import enAssignItemCodes from "../locales/en/assignItemCodes.json";
import enBulkCategoryDestinations from "../locales/en/bulkCategoryDestinations.json";
import enOnlineOrders from "../locales/en/onlineOrders.json";
import enOnlineOrderForm from "../locales/en/onlineOrderForm.json";
import enRestaurantOnlineOrders from "../locales/en/restaurantOnlineOrders.json";
import enForestWorks from "../locales/en/forestWorks.json";
import enLogisticsClients from "../locales/en/logisticsClients.json";
import enLogisticsWarehouseInventory from "../locales/en/logisticsWarehouseInventory.json";
import enLogisticsReceiving from "../locales/en/logisticsReceiving.json";
import enLogisticsPackingPicking from "../locales/en/logisticsPackingPicking.json";
import enLogisticsContainerLoading from "../locales/en/logisticsContainerLoading.json";
import enLogisticsReports from "../locales/en/logisticsReports.json";
import enLogisticsInvoicing from "../locales/en/logisticsInvoicing.json";
import enLogisticsSettings from "../locales/en/logisticsSettings.json";
import enLogisticsDashboard from "../locales/en/logisticsDashboard.json";
import enStaffPortal from "../locales/en/staffPortal.json";
import enBusinessAccount from "../locales/en/businessAccounts.json";

import enOrganizationStatus from "../locales/en/organizationStatus.json";
import frOrganizationStatus from "../locales/fr/organizationStatus.json";
import frCommon from "../locales/fr/common.json";
import frAuth from "../locales/fr/auth.json";
import frDashboard from "../locales/fr/dashboard.json";
import frNavbar from "../locales/fr/navbar.json";
import frChooseOrg from "../locales/fr/chooseOrg.json";
import frChooseOutlet from "../locales/fr/chooseOutlet.json";
import frChooseModule from "../locales/fr/chooseModule.json";
import frSidebar from "../locales/fr/sidebar.json";
import frSalesDashboard from "../locales/fr/salesDashboard.json";
import frSales from "../locales/fr/sales.json";
import frQuotations from "../locales/fr/quotations.json";
import frSaleReturns from "../locales/fr/saleReturns.json";
import frTransactions from "../locales/fr/transactions.json";
import frOutletShifts from "../locales/fr/outletShifts.json";
import frProducts from "../locales/fr/products.json";
import frEbmImports from "../locales/fr/ebmImports.json";
import frEbmPurchases from "../locales/fr/ebmPurchases.json";
import frSyncEbmNotices from "../locales/fr/syncEbmNotices.json";
import frSalesReports from "../locales/fr/salesReports.json";
import frGeneralSalesSettings from "../locales/fr/generalSalesSettings.json";
import frGeneralFinanceSettings from "../locales/fr/generalFinanceSettings.json";
import frSanctionTypes from "../locales/fr/sanctionTypes.json";
import frEmployeeSanctions from "../locales/fr/employeeSanctions.json";
import frCustomers from "../locales/fr/customers.json";
import frTaxRates from "../locales/fr/taxRates.json";
import frCategories from "../locales/fr/categories.json";
import frFacilityActivities from "../locales/fr/facilityActivities.json";
import frFacilityBookings from "../locales/fr/facilityBookings.json";
import frFacilityCalendar from "../locales/fr/facilityCalendar.json";
import frFacilityDashboard from "../locales/fr/facilityDashboard.json";
import frFacilityPayments from "../locales/fr/facilityPayments.json";
import frFacilitySettings from "../locales/fr/facilitySettings.json";
import frFacilityGuests from "../locales/fr/facilityGuests.json";
import frFacilityEnquiries from "../locales/fr/facilityEnquiries.json";
import frFacilityPortal from "../locales/fr/facilityPortal.json";
import frFacilityPortalSettings from "../locales/fr/facilityPortalSettings.json";
import frUnits from "../locales/fr/units.json";
import frUnitsConversions from "../locales/fr/unitsConversions.json";
import frPosOutlets from "../locales/fr/posOutlets.json";
import frPaymentMethods from "../locales/fr/paymentMethods.json";
import frPrintBarCodes from "../locales/fr/printBarCodes.json";
import frPresets from "../locales/fr/presets.json";
import frBreadcrumbs from "../locales/fr/breadcrumbs.json";
import frPos from "../locales/fr/pos.json";
import frKds from "../locales/fr/kds.json";
import frCart from "../locales/fr/cart.json";
import frPaymentScreen from "../locales/fr/paymentScreen.json";
import frSaleForm from "../locales/fr/saleForm.json";
import frBookingForm from "../locales/fr/bookingForm.json";
import frQuotationForm from "../locales/fr/quotationForm.json";
import frSaleReturnForm from "../locales/fr/saleReturnForm.json";
import frShiftModals from "../locales/fr/shiftModals.json";
import frProductForm from "../locales/fr/productForm.json";
import frUnitsForm from "../locales/fr/unitsForm.json";
import frImportEbmImports from "../locales/fr/importEbmImports.json";
import frSalesByItems from "../locales/fr/salesByItems.json";
import frSalesBySalesperson from "../locales/fr/salesBySalesperson.json";
import frSalesByServiceProvider from "../locales/fr/salesByServiceProvider.json";
import frSalesByCustomer from "../locales/fr/salesByCustomer.json";
import frBulkImport from "../locales/fr/bulkImport.json";
import frZReport from "../locales/fr/zReport.json";
import frXReport from "../locales/fr/xReport.json";
import frPluReport from "../locales/fr/pluReport.json";
import frEbmSalesReport from "../locales/fr/ebmSalesReport.json";
import frRestaurantDashboard from "../locales/fr/restaurantDashboard.json";
import frRestaurantOrders from "../locales/fr/restaurantOrders.json";
import frRestaurantOrderDetails from "../locales/fr/restaurantOrderDetails.json";
import frRestaurantTickets from "../locales/fr/restaurantTickets.json";
import frRestaurantSalesItems from "../locales/fr/restaurantSalesItems.json";
import frMenuItems from "../locales/fr/menuItems.json";
import frEbmBills from "../locales/fr/ebmBills.json";
import frWorkPeriods from "../locales/fr/workPeriods.json";
import frWorkPeriodDetails from "../locales/fr/workPeriodDetails.json";
import frCreateWorkPeriodReport from "../locales/fr/createWorkPeriodReport.json";
import frCloseWorkPeriod from "../locales/fr/closeWorkPeriod.json";
import frCreateShiftReport from "../locales/fr/createShiftReport.json";
import frCashierReports from "../locales/fr/cashierReports.json";
import frCashierSummaryReport from "../locales/fr/cashierSummaryReport.json";
import frGeneralCashierReports from "../locales/fr/generalCashierReports.json";
import frRestaurantAllowancesReport from "../locales/fr/restaurantAllowancesReport.json";
import frSalesByMenus from "../locales/fr/salesByMenus.json";
import frSalesByWaiters from "../locales/fr/salesByWaiters.json";
import frSalesByStations from "../locales/fr/salesByStations.json";
import frSalesCancellationReport from "../locales/fr/salesCancellationReport.json";
import frWaiterCancellationsReport from "../locales/fr/waiterCancellationsReport.json";
import frRestaurantSettings from "../locales/fr/restaurantSettings.json";
import frRestaurantDiscounts from "../locales/fr/restaurantDiscounts.json";
import frRestaurantLoyalty from "../locales/fr/restaurantLoyalty.json";
import frOrderStations from "../locales/fr/orderStations.json";
import frMenuCategories from "../locales/fr/menuCategories.json";
import frTables from "../locales/fr/tables.json";
import frRestaurantReports from "../locales/fr/restaurantReports.json";
import frDatatable from "../locales/fr/datatable.json";
import frLogoutModal from "../locales/fr/logoutModal.json";
import frRestaurantPosOrders from "../locales/fr/restaurantPosOrders.json";
import frRestaurantPosOrder from "../locales/fr/restaurantPosOrder.json";
import frNavUser from "../locales/fr/navUser.json";
import frChooseDestination from "../locales/fr/chooseDestination.json";
import frPaymentModal from "../locales/fr/paymentModal.json";
import frTransferModal from "../locales/fr/transferModal.json";
import frSplitBillModal from "../locales/fr/splitBillModal.json";
import frMergeOrderModal from "../locales/fr/mergeOrderModal.json";
import frInventoryLocations from "../locales/fr/inventoryLocations.json";
import frInventoryOverview from "../locales/fr/inventoryOverview.json";
import frManufacturingOverview from "../locales/fr/manufacturingOverview.json";
import frBoms from "../locales/fr/boms.json";
import frMenuRecipes from "../locales/fr/menuRecipes.json";
import frIngredientUsage from "../locales/fr/ingredientUsage.json";
import frBomForm from "../locales/fr/bomForm.json";
import frBomDetails from "../locales/fr/bomDetails.json";
import frProductionOrders from "../locales/fr/productionOrders.json";
import frProductionOrderForm from "../locales/fr/productionOrderForm.json";
import frProductionOrderDetails from "../locales/fr/productionOrderDetails.json";
import frMaterialRequests from "../locales/fr/materialRequests.json";
import frHousekeepingSupplies from "../locales/fr/housekeepingSupplies.json";
import frConferenceEvents from "../locales/fr/conferenceEvents.json";
import frHotelQuotations from "../locales/fr/hotelQuotations.json";
import frMaterialRequestForm from "../locales/fr/materialRequestForm.json";
import frMaterialRequestDetails from "../locales/fr/materialRequestDetails.json";
import frBatches from "../locales/fr/batches.json";
import frBatchDetails from "../locales/fr/batchDetails.json";
import frViewBatchesSheet from "../locales/fr/viewBatchesSheet.json";
import frSaleBatchDialog from "../locales/fr/saleBatchDialog.json";
import frManufacturingReports from "../locales/fr/manufacturingReports.json";
import frManufacturingSettings from "../locales/fr/manufacturingSettings.json";
import frHotelOverview from "../locales/fr/hotelOverview.json";
import frHotelCalendar from "../locales/fr/hotelCalendar.json";
import frHotelBookings from "../locales/fr/hotelBookings.json";
import frHotelServices from "../locales/fr/hotelServices.json";
import frHotelRatePlans from "../locales/fr/hotelRatePlans.json";
import frHotelRatePlanForm from "../locales/fr/hotelRatePlanForm.json";
import frHotelGuests from "../locales/fr/hotelGuests.json";
import frHotelPayments from "../locales/fr/hotelPayments.json";
import frHotelOnlineBookings from "../locales/fr/hotelOnlineBookings.json";
import frHotelFolios from "../locales/fr/hotelFolios.json";
import frHotelReports from "../locales/fr/hotelReports.json";
import frHotelRoomTypes from "../locales/fr/hotelRoomTypes.json";
import frHotelAgents from "../locales/fr/hotelAgents.json";
import frHotelCompanies from "../locales/fr/hotelCompanies.json";
import frHotelSettings from "../locales/fr/hotelSettings.json";
import frHotelFloors from "../locales/fr/hotelFloors.json";
import frHotelBedTypes from "../locales/fr/hotelBedTypes.json";
import frHotelAmenities from "../locales/fr/hotelAmenities.json";
import frHotelRooms from "../locales/fr/hotelRooms.json";
import frHotelRoomAvailability from "../locales/fr/hotelRoomAvailability.json";
import frHotelRoomConfig from "../locales/fr/hotelRoomConfig.json";
import frHotelCheckout from "../locales/fr/hotelCheckout.json";
import frHotelCredits from "../locales/fr/hotelCredits.json";
import frHotelPostCharge from "../locales/fr/hotelPostCharge.json";
import frHotelRecordService from "../locales/fr/hotelRecordService.json";
import frHotelAddAddon from "../locales/fr/hotelAddAddon.json";
import frHotelPostPayment from "../locales/fr/hotelPostPayment.json";
import frHotelExtendStay from "../locales/fr/hotelExtendStay.json";
import frHotelShortenStay from "../locales/fr/hotelShortenStay.json";
import frHotelRoomChange from "../locales/fr/hotelRoomChange.json";
import frHotelReactivateBooking from "../locales/fr/hotelReactivateBooking.json";
import frHotelArrivalsDeparturesReport from "../locales/fr/hotelArrivalsDeparturesReport.json";
import frHotelRoomRevenueReport from "../locales/fr/hotelRoomRevenueReport.json";
import frHotelGuestsByCountryReport from "../locales/fr/hotelGuestsByCountryReport.json";
import frHotelAgentCommissionsReport from "../locales/fr/hotelAgentCommissionsReport.json";
import frHousekeeping from "../locales/fr/housekeeping.json";
import frInventoryLocationDetails from "../locales/fr/inventoryLocationDetails.json";
import frUnitConversionSheet from "../locales/fr/unitConversionSheet.json";
import frEditInventorySheet from "../locales/fr/editInventorySheet.json";
import frImportInventoryModal from "../locales/fr/importInventoryModal.json";
import frImportInventory from "../locales/fr/importInventory.json";
import frStockCounting from "../locales/fr/stockCounting.json";
import frManualAdjustments from "../locales/fr/manualAdjustments.json";
import frInventoryItemAdjustments from "../locales/fr/inventoryItemAdjustments.json";
import frManualAdjustmentForm from "../locales/fr/manualAdjustmentForm.json";
import frStockThresholdSettings from "../locales/fr/stockThresholdSettings.json";
import frGeneralInventorySettings from "../locales/fr/generalInventorySettings.json";
import frSuppliers from "../locales/fr/suppliers.json";
import frStockItems from "../locales/fr/stockItems.json";
import frRequisitionDetails from "../locales/fr/requisitionDetails.json";
import frApprovalWorkflow from "../locales/fr/approvalWorkflow.json";
import frApprovalWorkflowConfig from "../locales/fr/approvalWorkflowConfig.json";
import frConvertToPo from "../locales/fr/convertToPo.json";
import frGeneralInformation from "../locales/fr/generalInformation.json";
import frThirdPartyIntegrations from "../locales/fr/thirdPartyIntegrations.json";
import frGeneralSettings from "../locales/fr/generalSettings.json";
import frApiKeysManagement from "../locales/fr/apiKeysManagement.json";
import frRequisitions from "../locales/fr/requisitions.json";
import frRequisitionForm from "../locales/fr/requisitionForm.json";
import frPurchaseOrders from "../locales/fr/purchaseOrders.json";
import frPurchaseOrdersForm from "../locales/fr/purchaseOrdersForm.json";
import frInternalTransfers from "../locales/fr/internalTransfers.json";
import frTransferForm from "../locales/fr/transferForm.json";
import frPurchaseInvoices from "../locales/fr/purchaseInvoices.json";
import frPurchaseDetail from "../locales/fr/purchaseDetail.json";
import frPurchaseInvoiceForm from "../locales/fr/purchaseInvoiceForm.json";
import frPurchasePaymentForm from "../locales/fr/purchasePaymentForm.json";
import frPurchasePaymentDetails from "../locales/fr/purchasePaymentDetails.json";
import frReceivePurchase from "../locales/fr/receivePurchase.json";
import frReceivePurchaseForm from "../locales/fr/receivePurchaseForm.json";
import frInventoryItems from "../locales/fr/inventoryItems.json";
import frSerializedItems from "../locales/fr/serializedItems.json";
import frBatchEntry from "../locales/fr/batchEntry.json";
import frInsurers from "../locales/fr/insurers.json";
import frInsurancePos from "../locales/fr/insurancePos.json";
import frInsuranceClaims from "../locales/fr/insuranceClaims.json";
import frInsuranceReports from "../locales/fr/insuranceReports.json";
import frInsurancePriceLists from "../locales/fr/insurancePriceLists.json";
import frSupplierPayments from "../locales/fr/supplierPayments.json";
import frStockItemCategories from "../locales/fr/stockItemCategories.json";
import frSendPurchaseOrderModal from "../locales/fr/sendPurchaseOrderModal.json";
import frAccountSettings from "../locales/fr/accountSettings.json";
import frRolesPermissions from "../locales/fr/rolesPermissions.json";
import frRoleForm from "../locales/fr/roleForm.json";
import frTransferDetails from "../locales/fr/transferDetails.json";
import frInvoiceDetails from "../locales/fr/invoiceDetails.json";
import frSystemUsers from "../locales/fr/systemUsers.json";
import frActivityLogs from "../locales/fr/activityLogs.json";
import frBilling from "../locales/fr/billing.json";
import frNightAudit from "../locales/fr/nightAudit.json";
import frDailyRevenueReport from "../locales/fr/dailyRevenueReport.json";
import frOccupancyReport from "../locales/fr/occupancyReport.json";
import frInHouseGuestReport from "../locales/fr/inHouseGuestReport.json";
import frCreateWorkRequest from "../locales/fr/createWorkRequest.json";
import frWorkDetails from "../locales/fr/workDetails.json";
import frLiquidProfiles from "../locales/fr/liquidProfiles.json";
import frBulkMenuUnits from "../locales/fr/bulkMenuUnits.json";
import frBulkProductUnits from "../locales/fr/bulkProductUnits.json";
import frProductPrices from "../locales/fr/productPrices.json";
import frAssignItemCodes from "../locales/fr/assignItemCodes.json";
import frBulkCategoryDestinations from "../locales/fr/bulkCategoryDestinations.json";
import frOnlineOrders from "../locales/fr/onlineOrders.json";
import frOnlineOrderForm from "../locales/fr/onlineOrderForm.json";
import frRestaurantOnlineOrders from "../locales/fr/restaurantOnlineOrders.json";
import frForestWorks from "../locales/fr/forestWorks.json";
import frLogisticsClients from "../locales/fr/logisticsClients.json";
import frLogisticsWarehouseInventory from "../locales/fr/logisticsWarehouseInventory.json";
import frLogisticsReceiving from "../locales/fr/logisticsReceiving.json";
import frLogisticsPackingPicking from "../locales/fr/logisticsPackingPicking.json";
import frLogisticsContainerLoading from "../locales/fr/logisticsContainerLoading.json";
import frLogisticsReports from "../locales/fr/logisticsReports.json";
import frLogisticsInvoicing from "../locales/fr/logisticsInvoicing.json";
import frLogisticsSettings from "../locales/fr/logisticsSettings.json";
import frLogisticsDashboard from "../locales/fr/logisticsDashboard.json";
import frStaffPortal from "../locales/fr/staffPortal.json";
import frBusinessAccount from "../locales/fr/businessAccounts.json";

import frBookingDetails from "../locales/fr/bookingDetails.json";
import enBookingDetails from "../locales/en/bookingDetails.json";

export const SUPPORTED_LANGUAGES = [
  { code: "en", label: "English", flag: "🇬🇧" },
  { code: "fr", label: "Français", flag: "🇫🇷" },
] as const;

export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number]["code"];

export const DEFAULT_LANGUAGE: SupportedLanguage = "en";

const resources = {
  en: {
    common: enCommon,
    organizationStatus: enOrganizationStatus,
    auth: enAuth,
    dashboard: enDashboard,
    navbar: enNavbar,
    chooseOrg: enChooseOrg,
    chooseOutlet: enChooseOutlet,
    chooseModule: enChooseModule,
    sidebar: enSidebar,
    salesDashboard: enSalesDashboard,
    sales: enSales,
    quotations: enQuotations,
    saleReturns: enSaleReturns,
    transactions: enTransactions,
    outletShifts: enOutletShifts,
    products: enProducts,
    ebmImports: enEbmImports,
    ebmPurchases: enEbmPurchases,
    syncEbmNotices: enSyncEbmNotices,
    salesReports: enSalesReports,
    generalSalesSettings: enGeneralSalesSettings,
    generalFinanceSettings: enGeneralFinanceSettings,
    generalInventorySettings: enGeneralInventorySettings,
    sanctionTypes: enSanctionTypes,
    employeeSanctions: enEmployeeSanctions,
    customers: enCustomers,
    taxRates: enTaxRates,
    categories: enCategories,
    facilityActivities: enFacilityActivities,
    facilityBookings: enFacilityBookings,
    facilityCalendar: enFacilityCalendar,
    facilityDashboard: enFacilityDashboard,
    facilityPayments: enFacilityPayments,
    facilitySettings: enFacilitySettings,
    facilityGuests: enFacilityGuests,
    facilityEnquiries: enFacilityEnquiries,
    facilityPortal: enFacilityPortal,
    facilityPortalSettings: enFacilityPortalSettings,
    units: enUnits,
    unitsConversions: enUnitsConversions,
    posOutlets: enPosOutlets,
    kds: enKds,
    paymentMethods: enPaymentMethods,
    printBarCodes: enPrintBarCodes,
    presets: enPresets,
    breadcrumbs: enBreadcrumbs,
    pos: enPos,
    cart: enCart,
    paymentScreen: enPaymentScreen,
    saleForm: enSaleForm,
    bookingForm: enBookingForm,
    quotationForm: enQuotationForm,
    saleReturnForm: enSaleReturnForm,
    shiftModals: enShiftModals,
    productForm: enProductForm,
    unitsForm: enUnitsForm,
    importEbmImports: enImportEbmImports,
    salesByItems: enSalesByItems,
    salesBySalesperson: enSalesBySalesperson,
    salesByServiceProvider: enSalesByServiceProvider,
    salesByCustomer: enSalesByCustomer,
    bulkImport: enBulkImport,
    zReport: enZReport,
    xReport: enXReport,
    pluReport: enPluReport,
    ebmSalesReport: enEbmSalesReport,
    restaurantDashboard: enRestaurantDashboard,
    restaurantOrders: enRestaurantOrders,
    restaurantOrderDetails: enRestaurantOrderDetails,
    restaurantTickets: enRestaurantTickets,
    restaurantSalesItems: enRestaurantSalesItems,
    menuItems: enMenuItems,
    ebmBills: enEbmBills,
    workPeriods: enWorkPeriods,
    workPeriodDetails: enWorkPeriodDetails,
    createWorkPeriodReport: enCreateWorkPeriodReport,
    closeWorkPeriod: enCloseWorkPeriod,
    createShiftReport: enCreateShiftReport,
    cashierReports: enCashierReports,
    cashierSummaryReport: enCashierSummaryReport,
    generalCashierReports: enGeneralCashierReports,
    restaurantAllowancesReport: enRestaurantAllowancesReport,
    salesByMenus: enSalesByMenus,
    salesByWaiters: enSalesByWaiters,
    salesByStations: enSalesByStations,
    salesCancellationReport: enSalesCancellationReport,
    waiterCancellationsReport: enWaiterCancellationsReport,
    restaurantSettings: enRestaurantSettings,
    restaurantDiscounts: enRestaurantDiscounts,
    restaurantLoyalty: enRestaurantLoyalty,
    orderStations: enOrderStations,
    menuCategories: enMenuCategories,
    tables: enTables,
    restaurantReports: enRestaurantReports,
    datatable: enDatatable,
    logoutModal: enLogoutModal,
    restaurantPosOrders: enRestaurantPosOrders,
    restaurantPosOrder: enRestaurantPosOrder,
    navUser: enNavUser,
    chooseDestination: enChooseDestination,
    paymentModal: enPaymentModal,
    transferModal: enTransferModal,
    splitBillModal: enSplitBillModal,
    mergeOrderModal: enMergeOrderModal,
    inventoryLocations: enInventoryLocations,
    inventoryOverview: enInventoryOverview,
    manufacturingOverview: enManufacturingOverview,
    boms: enBoms,
    menuRecipes: enMenuRecipes,
    ingredientUsage: enIngredientUsage,
    bomForm: enBomForm,
    bomDetails: enBomDetails,
    productionOrders: enProductionOrders,
    productionOrderForm: enProductionOrderForm,
    productionOrderDetails: enProductionOrderDetails,
    materialRequests: enMaterialRequests,
    housekeepingSupplies: enHousekeepingSupplies,
    conferenceEvents: enConferenceEvents,
    hotelQuotations: enHotelQuotations,
    materialRequestForm: enMaterialRequestForm,
    materialRequestDetails: enMaterialRequestDetails,
    batches: enBatches,
    batchDetails: enBatchDetails,
    viewBatchesSheet: enViewBatchesSheet,
    saleBatchDialog: enSaleBatchDialog,
    manufacturingReports: enManufacturingReports,
    manufacturingSettings: enManufacturingSettings,
    hotelOverview: enHotelOverview,
    hotelCalendar: enHotelCalendar,
    hotelBookings: enHotelBookings,
    hotelServices: enHotelServices,
    hotelRatePlans: enHotelRatePlans,
    hotelRatePlanForm: enHotelRatePlanForm,
    hotelGuests: enHotelGuests,
    hotelPayments: enHotelPayments,
    hotelOnlineBookings: enHotelOnlineBookings,
    hotelFolios: enHotelFolios,
    hotelReports: enHotelReports,
    hotelRoomTypes: enHotelRoomTypes,
    hotelAgents: enHotelAgents,
    hotelCompanies: enHotelCompanies,
    hotelSettings: enHotelSettings,
    hotelFloors: enHotelFloors,
    hotelBedTypes: enHotelBedTypes,
    hotelAmenities: enHotelAmenities,
    hotelRooms: enHotelRooms,
    hotelRoomAvailability: enHotelRoomAvailability,
    hotelRoomConfig: enHotelRoomConfig,
    hotelCheckout: enHotelCheckout,
    hotelCredits: enHotelCredits,
    hotelPostCharge: enHotelPostCharge,
    hotelRecordService: enHotelRecordService,
    hotelAddAddon: enHotelAddAddon,
    hotelPostPayment: enHotelPostPayment,
    hotelExtendStay: enHotelExtendStay,
    hotelShortenStay: enHotelShortenStay,
    hotelRoomChange: enHotelRoomChange,
    hotelReactivateBooking: enHotelReactivateBooking,
    hotelArrivalsDeparturesReport: enHotelArrivalsDeparturesReport,
    hotelRoomRevenueReport: enHotelRoomRevenueReport,
    hotelGuestsByCountryReport: enHotelGuestsByCountryReport,
    hotelAgentCommissionsReport: enHotelAgentCommissionsReport,
    housekeeping: enHousekeeping,
    bookingDetails: enBookingDetails,
    inventoryLocationDetails: enInventoryLocationDetails,
    unitConversionSheet: enUnitConversionSheet,
    editInventorySheet: enEditInventorySheet,
    importInventoryModal: enImportInventoryModal,
    importInventory: enImportInventory,
    stockCounting: enStockCounting,
    manualAdjustments: enManualAdjustments,
    inventoryItemAdjustments: enInventoryItemAdjustments,
    manualAdjustmentForm: enManualAdjustmentForm,
    stockThresholdSettings: enStockThresholdSettings,
    // generalInventorySettings: enGeneralInventorySettings,
    suppliers: enSuppliers,
    stockItems: enStockItems,
    requisitionDetails: enRequisitionDetails,
    approvalWorkflow: enApprovalWorkflow,
    approvalWorkflowConfig: enApprovalWorkflowConfig,
    convertToPo: enConvertToPo,
    generalInformation: enGeneralInformation,
    thirdPartyIntegrations: enThirdPartyIntegrations,
    generalSettings: enGeneralSettings,
    apiKeysManagement: enApiKeysManagement,
    requisitions: enRequisitions,
    requisitionForm: enRequisitionForm,
    purchaseOrders: enPurchaseOrders,
    purchaseOrdersForm: enPurchaseOrdersForm,
    internalTransfers: enInternalTransfers,
    transferForm: enTransferForm,
    purchaseInvoices: enPurchaseInvoices,
    purchaseDetail: enPurchaseDetail,
    purchaseInvoiceForm: enPurchaseInvoiceForm,
    purchasePaymentForm: enPurchasePaymentForm,
    purchasePaymentDetails: enPurchasePaymentDetails,
    receivePurchase: enReceivePurchase,
    receivePurchaseForm: enReceivePurchaseForm,
    inventoryItems: enInventoryItems,
    serializedItems: enSerializedItems,
    batchEntry: enBatchEntry,
    insurers: enInsurers,
    insurancePos: enInsurancePos,
    insuranceClaims: enInsuranceClaims,
    insuranceReports: enInsuranceReports,
    insurancePriceLists: enInsurancePriceLists,
    supplierPayments: enSupplierPayments,
    stockItemCategories: enStockItemCategories,
    sendPurchaseOrderModal: enSendPurchaseOrderModal,
    accountSettings: enAccountSettings,
    rolesPermissions: enRolesPermissions,
    roleForm: enRoleForm,
    transferDetails: enTransferDetails,
    invoiceDetails: enInvoiceDetails,
    systemUsers: enSystemUsers,
    activityLogs: enActivityLogs,
    billing: enBilling,
    nightAudit: enNightAudit,
    dailyRevenueReport: enDailyRevenueReport,
    occupancyReport: enOccupancyReport,
    inHouseGuestReport: enInHouseGuestReport,
    createWorkRequest: enCreateWorkRequest,
    workDetails: enWorkDetails,
    liquidProfiles: enLiquidProfiles,
    bulkMenuUnits: enBulkMenuUnits,
    bulkProductUnits: enBulkProductUnits,
    productPrices: enProductPrices,
    assignItemCodes: enAssignItemCodes,
    bulkCategoryDestinations: enBulkCategoryDestinations,
    onlineOrders: enOnlineOrders,
    onlineOrderForm: enOnlineOrderForm,
    restaurantOnlineOrders: enRestaurantOnlineOrders,
    forestWorks: enForestWorks,
    logisticsClients: enLogisticsClients,
    logisticsWarehouseInventory: enLogisticsWarehouseInventory,
    logisticsReceiving: enLogisticsReceiving,
    logisticsPackingPicking: enLogisticsPackingPicking,
    logisticsContainerLoading: enLogisticsContainerLoading,
    logisticsReports: enLogisticsReports,
    logisticsInvoicing: enLogisticsInvoicing,
    logisticsSettings: enLogisticsSettings,
    logisticsDashboard: enLogisticsDashboard,
    staffPortal: enStaffPortal,
    businessAccounts: enBusinessAccount,
  },
  fr: {
    common: frCommon,
    organizationStatus: frOrganizationStatus,
    auth: frAuth,
    dashboard: frDashboard,
    navbar: frNavbar,
    chooseOrg: frChooseOrg,
    chooseOutlet: frChooseOutlet,
    chooseModule: frChooseModule,
    sidebar: frSidebar,
    salesDashboard: frSalesDashboard,
    sales: frSales,
    quotations: frQuotations,
    saleReturns: frSaleReturns,
    transactions: frTransactions,
    outletShifts: frOutletShifts,
    products: frProducts,
    ebmImports: frEbmImports,
    ebmPurchases: frEbmPurchases,
    syncEbmNotices: frSyncEbmNotices,
    salesReports: frSalesReports,
    generalSalesSettings: frGeneralSalesSettings,
    generalFinanceSettings: frGeneralFinanceSettings,
    sanctionTypes: frSanctionTypes,
    employeeSanctions: frEmployeeSanctions,
    customers: frCustomers,
    taxRates: frTaxRates,
    categories: frCategories,
    facilityActivities: frFacilityActivities,
    facilityBookings: frFacilityBookings,
    facilityCalendar: frFacilityCalendar,
    facilityDashboard: frFacilityDashboard,
    facilityPayments: frFacilityPayments,
    facilitySettings: frFacilitySettings,
    facilityGuests: frFacilityGuests,
    facilityEnquiries: frFacilityEnquiries,
    facilityPortal: frFacilityPortal,
    facilityPortalSettings: frFacilityPortalSettings,
    units: frUnits,
    unitsConversions: frUnitsConversions,
    posOutlets: frPosOutlets,
    kds: frKds,
    paymentMethods: frPaymentMethods,
    printBarCodes: frPrintBarCodes,
    presets: frPresets,
    breadcrumbs: frBreadcrumbs,
    pos: frPos,
    cart: frCart,
    paymentScreen: frPaymentScreen,
    saleForm: frSaleForm,
    bookingForm: frBookingForm,
    quotationForm: frQuotationForm,
    saleReturnForm: frSaleReturnForm,
    shiftModals: frShiftModals,
    productForm: frProductForm,
    unitsForm: frUnitsForm,
    importEbmImports: frImportEbmImports,
    salesByItems: frSalesByItems,
    salesBySalesperson: frSalesBySalesperson,
    salesByServiceProvider: frSalesByServiceProvider,
    salesByCustomer: frSalesByCustomer,
    bulkImport: frBulkImport,
    zReport: frZReport,
    xReport: frXReport,
    pluReport: frPluReport,
    ebmSalesReport: frEbmSalesReport,
    restaurantDashboard: frRestaurantDashboard,
    restaurantOrders: frRestaurantOrders,
    restaurantOrderDetails: frRestaurantOrderDetails,
    restaurantTickets: frRestaurantTickets,
    restaurantSalesItems: frRestaurantSalesItems,
    menuItems: frMenuItems,
    ebmBills: frEbmBills,
    workPeriods: frWorkPeriods,
    workPeriodDetails: frWorkPeriodDetails,
    createWorkPeriodReport: frCreateWorkPeriodReport,
    closeWorkPeriod: frCloseWorkPeriod,
    createShiftReport: frCreateShiftReport,
    cashierReports: frCashierReports,
    cashierSummaryReport: frCashierSummaryReport,
    generalCashierReports: frGeneralCashierReports,
    restaurantAllowancesReport: frRestaurantAllowancesReport,
    salesByMenus: frSalesByMenus,
    salesByWaiters: frSalesByWaiters,
    salesByStations: frSalesByStations,
    salesCancellationReport: frSalesCancellationReport,
    waiterCancellationsReport: frWaiterCancellationsReport,
    restaurantSettings: frRestaurantSettings,
    restaurantDiscounts: frRestaurantDiscounts,
    restaurantLoyalty: frRestaurantLoyalty,
    orderStations: frOrderStations,
    menuCategories: frMenuCategories,
    tables: frTables,
    restaurantReports: frRestaurantReports,
    datatable: frDatatable,
    logoutModal: frLogoutModal,
    restaurantPosOrders: frRestaurantPosOrders,
    restaurantPosOrder: frRestaurantPosOrder,
    navUser: frNavUser,
    chooseDestination: frChooseDestination,
    paymentModal: frPaymentModal,
    transferModal: frTransferModal,
    splitBillModal: frSplitBillModal,
    mergeOrderModal: frMergeOrderModal,
    inventoryLocations: frInventoryLocations,
    inventoryOverview: frInventoryOverview,
    manufacturingOverview: frManufacturingOverview,
    boms: frBoms,
    menuRecipes: frMenuRecipes,
    ingredientUsage: frIngredientUsage,
    bomForm: frBomForm,
    bomDetails: frBomDetails,
    productionOrders: frProductionOrders,
    productionOrderForm: frProductionOrderForm,
    productionOrderDetails: frProductionOrderDetails,
    materialRequests: frMaterialRequests,
    housekeepingSupplies: frHousekeepingSupplies,
    conferenceEvents: frConferenceEvents,
    hotelQuotations: frHotelQuotations,
    materialRequestForm: frMaterialRequestForm,
    materialRequestDetails: frMaterialRequestDetails,
    batches: frBatches,
    batchDetails: frBatchDetails,
    viewBatchesSheet: frViewBatchesSheet,
    saleBatchDialog: frSaleBatchDialog,
    manufacturingReports: frManufacturingReports,
    manufacturingSettings: frManufacturingSettings,
    hotelOverview: frHotelOverview,
    hotelCalendar: frHotelCalendar,
    hotelBookings: frHotelBookings,
    hotelServices: frHotelServices,
    hotelRatePlans: frHotelRatePlans,
    hotelRatePlanForm: frHotelRatePlanForm,
    hotelGuests: frHotelGuests,
    hotelPayments: frHotelPayments,
    hotelOnlineBookings: frHotelOnlineBookings,
    hotelFolios: frHotelFolios,
    hotelReports: frHotelReports,
    hotelRoomTypes: frHotelRoomTypes,
    hotelAgents: frHotelAgents,
    hotelCompanies: frHotelCompanies,
    hotelSettings: frHotelSettings,
    hotelFloors: frHotelFloors,
    hotelBedTypes: frHotelBedTypes,
    hotelAmenities: frHotelAmenities,
    hotelRooms: frHotelRooms,
    hotelRoomAvailability: frHotelRoomAvailability,
    hotelRoomConfig: frHotelRoomConfig,
    hotelCheckout: frHotelCheckout,
    hotelCredits: frHotelCredits,
    hotelPostCharge: frHotelPostCharge,
    hotelRecordService: frHotelRecordService,
    hotelAddAddon: frHotelAddAddon,
    hotelPostPayment: frHotelPostPayment,
    hotelExtendStay: frHotelExtendStay,
    hotelShortenStay: frHotelShortenStay,
    hotelRoomChange: frHotelRoomChange,
    hotelReactivateBooking: frHotelReactivateBooking,
    hotelArrivalsDeparturesReport: frHotelArrivalsDeparturesReport,
    hotelRoomRevenueReport: frHotelRoomRevenueReport,
    hotelGuestsByCountryReport: frHotelGuestsByCountryReport,
    hotelAgentCommissionsReport: frHotelAgentCommissionsReport,
    housekeeping: frHousekeeping,
    bookingDetails: frBookingDetails,
    inventoryLocationDetails: frInventoryLocationDetails,
    unitConversionSheet: frUnitConversionSheet,
    editInventorySheet: frEditInventorySheet,
    importInventoryModal: frImportInventoryModal,
    importInventory: frImportInventory,
    stockCounting: frStockCounting,
    manualAdjustments: frManualAdjustments,
    inventoryItemAdjustments: frInventoryItemAdjustments,
    manualAdjustmentForm: frManualAdjustmentForm,
    stockThresholdSettings: frStockThresholdSettings,
    generalInventorySettings: frGeneralInventorySettings,
    suppliers: frSuppliers,
    stockItems: frStockItems,
    requisitionDetails: frRequisitionDetails,
    approvalWorkflow: frApprovalWorkflow,
    approvalWorkflowConfig: frApprovalWorkflowConfig,
    convertToPo: frConvertToPo,
    generalInformation: frGeneralInformation,
    thirdPartyIntegrations: frThirdPartyIntegrations,
    generalSettings: frGeneralSettings,
    apiKeysManagement: frApiKeysManagement,
    requisitions: frRequisitions,
    requisitionForm: frRequisitionForm,
    purchaseOrders: frPurchaseOrders,
    purchaseOrdersForm: frPurchaseOrdersForm,
    internalTransfers: frInternalTransfers,
    transferForm: frTransferForm,
    purchaseInvoices: frPurchaseInvoices,
    purchaseDetail: frPurchaseDetail,
    purchaseInvoiceForm: frPurchaseInvoiceForm,
    purchasePaymentForm: frPurchasePaymentForm,
    purchasePaymentDetails: frPurchasePaymentDetails,
    receivePurchase: frReceivePurchase,
    receivePurchaseForm: frReceivePurchaseForm,
    inventoryItems: frInventoryItems,
    serializedItems: frSerializedItems,
    batchEntry: frBatchEntry,
    insurers: frInsurers,
    insurancePos: frInsurancePos,
    insuranceClaims: frInsuranceClaims,
    insuranceReports: frInsuranceReports,
    insurancePriceLists: frInsurancePriceLists,
    supplierPayments: frSupplierPayments,
    stockItemCategories: frStockItemCategories,
    sendPurchaseOrderModal: frSendPurchaseOrderModal,
    accountSettings: frAccountSettings,
    rolesPermissions: frRolesPermissions,
    roleForm: frRoleForm,
    transferDetails: frTransferDetails,
    invoiceDetails: frInvoiceDetails,
    systemUsers: frSystemUsers,
    activityLogs: frActivityLogs,
    billing: frBilling,
    nightAudit: frNightAudit,
    dailyRevenueReport: frDailyRevenueReport,
    occupancyReport: frOccupancyReport,
    inHouseGuestReport: frInHouseGuestReport,
    createWorkRequest: frCreateWorkRequest,
    workDetails: frWorkDetails,
    liquidProfiles: frLiquidProfiles,
    bulkMenuUnits: frBulkMenuUnits,
    bulkProductUnits: frBulkProductUnits,
    productPrices: frProductPrices,
    assignItemCodes: frAssignItemCodes,
    bulkCategoryDestinations: frBulkCategoryDestinations,
    onlineOrders: frOnlineOrders,
    onlineOrderForm: frOnlineOrderForm,
    restaurantOnlineOrders: frRestaurantOnlineOrders,
    forestWorks: frForestWorks,
    logisticsClients: frLogisticsClients,
    logisticsWarehouseInventory: frLogisticsWarehouseInventory,
    logisticsReceiving: frLogisticsReceiving,
    logisticsPackingPicking: frLogisticsPackingPicking,
    logisticsContainerLoading: frLogisticsContainerLoading,
    logisticsReports: frLogisticsReports,
    logisticsInvoicing: frLogisticsInvoicing,
    logisticsSettings: frLogisticsSettings,
    logisticsDashboard: frLogisticsDashboard,
    staffPortal: frStaffPortal,
    businessAccounts: frBusinessAccount,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: DEFAULT_LANGUAGE,
    defaultNS: "common",
    ns: [
      "common",
      "auth",
      "dashboard",
      "navbar",
      "chooseOrg",
      "chooseModule",
      "sidebar",
      "salesDashboard",
      "sales",
      "generalSalesSettings",
      "generalFinanceSettings",
      "generalInventorySettings",
      "quotations",
      "saleReturns",
      "shiftModals",
      "workDetails",
    ],

    interpolation: {
      escapeValue: false, // React already escapes values
    },

    detection: {
      // Order of language detection
      order: ["localStorage", "navigator"],
      // Cache user language preference
      caches: ["localStorage"],
      lookupLocalStorage: "preferredLanguage",
    },
  });

export default i18n;
